import get from "lodash/get";
import isNil from "lodash/isNil";
import { Controller } from "react-hook-form";
import NumberFormat, { NumberFormatValues } from "react-number-format";
import { TextControlProps } from "types";
import ErrorMessage from "../error-message/error-message";

export interface NumericControlProps extends Omit<TextControlProps, "type" | "compareTo"> {
	format?: string;
	prefix?: string;
	limit?: number;
	allowNegative?: boolean;
	allowLeadingZeros?: boolean;
	decimalScale?: number;
	thousandSeparator?: string | boolean;
	fixedDecimalScale?: boolean;
}

// https://www.npmjs.com/package/react-number-format
const NumericControl = (props: NumericControlProps) => {
	const { control, formState: { errors } } = props.formMethods ?? { formState: {} };

	const rules: any = {};
	rules.required = (props.required) ? "Dato requerido" : false;
	rules.pattern = props.pattern;
	rules.minLength = props.minLength;

	const withLimit = (limit: number) => (inputObj: NumberFormatValues) => {
		const { value } = inputObj;
		return value === "" || parseFloat(value) <= limit;
	};

	return (
		<div className="inputField">
			<Controller
				name={props.name as any}
				control={(control as any)}
				defaultValue={""}
				rules={rules}
				render={({ field }) =>
					<NumberFormat
						className={`${errors?.[props.name] && "is-invalid"}`}
						format={props.format}
						placeholder={" "}
						maxLength={props.maxLength}
						tabIndex={props.tabIndex}
						readOnly={props.readOnly}
						allowNegative={props.allowNegative}
						allowLeadingZeros={props.allowLeadingZeros}
						decimalScale={props.decimalScale}
						thousandSeparator={props.thousandSeparator}
						prefix={props.prefix}
						fixedDecimalScale={props.fixedDecimalScale}
						isAllowed={!isNil(props.limit) ? withLimit(props.limit) : undefined}
						onValueChange={(values: NumberFormatValues) => {
							field.onChange(values.value);
						}}
						value={field.value}
					/>
				}
			/>

			<span className={`${props.readOnly && "is-readOnlyPlaceholder"}`}>{props.label}</span>
			<ErrorMessage error={errors && get(errors, props.name)} />
		</div>
	);
};

export default NumericControl;